/*
 * @Author: bbqin
 * @Date: 2022-10-28 16:37:36
 * @LastEditTime: 2023-08-29 14:16:16
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Hyperlink\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { pageTo, ajax, toast, getMultiLang } from '@platform/api';
import { Dropdown, Menu } from '@platform/base';
const { Item, Divider, SubMenu, ItemGroup } = Menu;

require('./index.less');

// 判断是否是url
function IsURL(str_url) {
    str_url = String(str_url);
    var strRegex = "^((https|http|ftp|rtsp|mms)?://)" +
        "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + //ftp的user@ 
        "(([0-9]{1,3}\.){3}[0-9]{1,3}" + // IP形式的URL- 199.194.52.184 
        "|" + // 允许IP和DOMAIN（域名）
        "([0-9a-z_!~*'()-]+\.)*" + // 域名- www. 
        "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." + // 二级域名 
        "[a-z]{2,6})" + // first level domain- .com or .museum 
        "(:[0-9]{1,4})?" + // 端口- :80 
        "((/?)|" + // a slash isn't required if there is no file name 
        "(/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+/?)$";
    var re = new RegExp(strRegex);
    //re.test()
    if (re.test(str_url)) {
        return (true);
    } else {
        return (false);
    }
}

// 给链接加上http://
function completionUrl(url = '') {
    let forwardUrl = 'http';
    let forwardUrls = 'https';
    if (!url) {
        // 避免为空时报错
        return url;
    }
    return (!url.includes(`${forwardUrl}://`) && !url.includes(`${forwardUrls}://`)) ? `${forwardUrl}://` + url : url;
}

// 获取超链接的值
function getHyperlinkValue(params) {
    let {
        datatype,
        hyperlinkflag,
        hyperlinktype,
        hyperlinkname,
        hyperlinkurl,
        value,
        browse,
    } = params;

    let result = value;

    switch (true) {
        // 超链接 静态地址  浏览态和编辑态  都显示为超链接
        case datatype == '1' && hyperlinkflag && hyperlinktype === '2':
            result = hyperlinkname || hyperlinkurl;
            break;
        // 超链接  字段内容  浏览态显示地址  编辑态  可以录入
        case datatype == '1' && hyperlinkflag && hyperlinktype === '1' && browse:
            result = hyperlinkname || value;
            break;
        // 超链接  非外部链接
        case browse && hyperlinkflag:
            result = value;
            break;
        // 非超链接  浏览态
        case browse && !hyperlinkflag:
        default:
            result = value;
            break;
    }

    return result;
}

class Hyperlink extends Component {
    constructor(props) {
        super(props);
        this.state = { options: [] };
    }

    componentDidMount() {
        // 初始化多语加载 
        getMultiLang({
            moduleId: "page_form",
            callback: json => {
                this.setState({ langJson: json });
            },
        });
    }

    onClick = () => {
        let { hyperlinkflag, browse, pageId, areaCode, attrCode, dataId } = this.props;
        dataId = String(typeof dataId === 'undefined' ? '' : dataId);
        if (hyperlinkflag && browse && dataId) {
            ajax({
                url: '/nccloud/platform/pub/gethyperlink.do',
                method: 'post',
                data:
                {
                    templetId: pageId,
                    areaCode,
                    code: attrCode,
                    dataId,
                }
                ,
                success: res => {
                    if (res.data) {
                        let { appPage = {}, classid = '' } = res.data;
                        if (Array.isArray(appPage)) {
                            if (appPage.length === 1) {
                                pageTo.openTo(appPage[0].pageurl, {
                                    appcode: appPage[0].parentcode,
                                    id: dataId,
                                    pagecode: appPage[0].pagecode,
                                    classid: classid,
                                });
                            } else {
                                this.setState({ options: appPage, classid });
                            }
                        } else if (appPage && appPage.pageurl) {
                            pageTo.openTo(appPage.pageurl, {
                                appcode: appPage.parentcode,
                                id: dataId,
                                pagecode: appPage.pagecode,
                                classid: classid,
                            });
                        }

                    }
                },
            });
        }
    };

    onItemClick = (appPage = {}) => {
        let { dataId } = this.props;
        let { classid = '' } = this.state;
        dataId = String(dataId);
        pageTo.openTo(appPage.pageurl, {
            appcode: appPage.parentcode,
            id: dataId,
            pagecode: appPage.pagecode,
            classid: classid,
        });
    };

    render() {
        let {
            children,
            datatype, hyperlinkflag, hyperlinktype, hyperlinkname, hyperlinkurl,
            value, browse,
            pageId, areaCode, attrCode, dataId,
            className,
            fontSize,
            color
        } = this.props;
        let { options, langJson = {} } = this.state;

        let $element = null;

        switch (true) {
            // 超链接 静态地址  浏览态和编辑态  都显示为超链接
            case datatype == '1' && hyperlinkflag && hyperlinktype === '2':
                $element = <a style={{ cursor: 'pointer', fontSize: fontSize, color: color }}
                    className={`normal-hyperlink ${className || ''}`}
                    onClick={() => {
                        // TODO  校验地址 xss安全处理等
                        if (!IsURL(hyperlinkurl) || !hyperlinkurl) {
                            toast({
                                mark: 'hyperlink-wraning',
                                color: 'danger',
                                title: langJson['page-form-0009'],
                                content: langJson['page-invalid-hyperlink'],
                            });
                            return;
                        }
                        window.open(completionUrl(hyperlinkurl), 'outside-link' + value + hyperlinkurl);
                    }}>{hyperlinkname || hyperlinkurl}</a>;
                break;
            // 超链接  字段内容  浏览态显示地址  编辑态  可以录入
            case datatype == '1' && hyperlinkflag && hyperlinktype === '1' && browse:
                $element = <a style={{ cursor: 'pointer', fontSize: fontSize, color: color }}
                    className={`normal-hyperlink ${className || ''}`}
                    onClick={() => {
                        // TODO  校验地址 xss安全处理等
                        if (!IsURL(value) || !value) {
                            toast({
                                mark: 'hyperlink-wraning',
                                color: 'danger',
                                title: langJson['page-form-0009'],
                                content: langJson['page-invalid-hyperlink-url'],
                            });
                            return;
                        }
                        window.open(completionUrl(value), 'outside-link' + value + hyperlinkurl);
                    }}>{hyperlinkname || value}</a>;
                break;
            case datatype == '1' && hyperlinkflag && !hyperlinktype && browse:
                $element = <a
                    style={{ cursor: 'pointer', fontSize: fontSize, color: color }}
                    className={`normal-hyperlink ${className || ''}`}
                    onClick={() => {
                        toast({
                            mark: 'hyperlink-wraning',
                            color: 'danger',
                            title: langJson['page-form-0009'],
                            content: langJson['page-invalid-hyperlink'],
                        });
                    }}>{children}</a>;
                break;
            // 超链接  非外部链接
            case browse && hyperlinkflag:
                // $element = <a style={{ cursor: 'pointer' }}
                //     className={`normal-hyperlink ${className || ''}`}
                //     onClick={() => handleClick(hyperlinkflag, attrcode, status, getStore(['pageid']), singleFormCode, (getItemValue(attrcode) || {}).value)}>{itemDom}</a>;
                $element = <Dropdown
                    trigger={['click']}
                    minOverlayWidthMatchTrigger={false}
                    overlay={(
                        <Menu className="hyperlink-overlay-wrapper">
                            {options.map((item, index) => {
                                return <Item key={index} onClick={this.onItemClick.bind(this, item)}>{item.pagename}</Item>;
                            })}
                        </Menu>
                    )}
                // visible={this.state.visible}
                // onVisibleChange={visible => {
                //     this.setState({ visible });
                // }}
                >
                    <a

                        style={{ cursor: 'pointer', fontSize: fontSize, color: color }}
                        className={`normal-hyperlink ${className || ''}`}
                        onClick={this.onClick}>{children}</a>
                </Dropdown>;
                break;
            // 非超链接  浏览态
            case browse && !hyperlinkflag:
            default:
                $element = children;
                break;
        }

        return $element;
    }
}
Hyperlink.IsURL = IsURL;
Hyperlink.completionUrl = completionUrl;
Hyperlink.getHyperlinkValue = getHyperlinkValue;
export default Hyperlink;